module.exports = __webpack_public_path__ + "static/media/sit.9f203438.jpg";